<template>
  <div id="edit-employee">
    <h3>Edit Employee</h3>
    <form @submit.prevent="editEmployee" class="col s12">
      <div class="input-field col s12">
        <input disabled type="text" v-model="employeeId" required />
        <!-- <label>Employee ID</label> -->
      </div>
      <div class="input-field col s12">
        <input type="text" v-model="name" required />
        <!-- <label>Employee Name</label> -->
      </div>
      <div class="input-field col s12">
        <input type="text" v-model="department" required />
        <!-- <label>Employee Department</label> -->
      </div>
      <div class="input-field col s12">
        <input type="text" v-model="position" required />
        <!-- <label>Employee Position</label> -->
      </div>
      <button type="submit" class="btn">Update</button>
      <router-link to="/" class="btn grey">Cancel</router-link>
    </form>
  </div>
</template>

<script>
import db from "../fbInit";
export default {
  name: "edit-employee",
  data() {
    return {
      employeeId: null,
      name: null,
      department: null,
      position: null
    };
  },
  beforeRouteEnter(to, from, next) {
    // ...
    db.collection("employees")
      .where("employeeId", "==", to.params.employeeId)
      .get()
      .then(querySnapShot => {
        querySnapShot.forEach(doc => {
          next(vm => {
            (vm.employeeId = doc.data().employeeId),
              (vm.name = doc.data().name),
              (vm.department = doc.data().department),
              (vm.position = doc.data().position);
          });
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      db.collection("employees")
        .where("employeeId", "==", this.$route.params.employeeId)
        .get()
        .then(querySnapShot => {
          querySnapShot.forEach(doc => {
            (this.employeeId = doc.data().employeeId),
              (this.name = doc.data().name),
              (this.department = doc.data().department),
              (this.position = doc.data().position);
          });
        });
    },
    editEmployee() {
      db.collection("employees")
        .where("employeeId", "==", this.$route.params.employeeId)
        .get()
        .then(querySnapShot => {
          querySnapShot.forEach(doc => {
            doc.ref.update({
              employeeId: this.employeeId,
              name: this.name,
              department: this.department,
              position: this.position
            })
          })
        })
        .then(() => {
          this.$router.push({name: 'View-Employee', params: {employeeId: this.employeeId}})
        })
        .catch(err => console.log(err))
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Employee/EditEmployee.vue